import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Box, Button, List } from "devextreme-react";
import { Item } from "devextreme-react/box";
import { chartList, chartTypeList } from "./data";
import {
  update,
  updateChartType,
  updateChartSubtype,
} from "./Redux/chartTypeSlice";
import ButtonOKCancel from "./ButtonOKCancel";

export default function ChartTypeContainer(props) {
  const { chartTypePupupRef } = props;

  const [chartSubtypeList, setChartSubtypeList] = useState(null);
  const [chartType, setChartType] = useState(null);
  const [chartSubtype, setChartSubtype] = useState(null);

  const dispatch = useDispatch();

  // let chartType = null;
  // let chartSubtype = null;

  const onTypeListItemClick = (e) => {
    // dispatch(updateChartType(e.itemData.value));

    setChartSubtypeList(chartTypeList[e.itemData.value]);
    setChartType(e.itemData.value);
  };

  const onSubtypeListItemClick = (e) => {
    setChartSubtype(e.itemData.id);
  };

  const onOkClick = (e) => {
    dispatch(
      update({
        type: chartType,
        subtype: chartSubtype,
      })
    );

    chartTypePupupRef.current.instance.hide();
  };

  const onCancelClick = (e) => {
    chartTypePupupRef.current.instance.hide();
  };

  return (
    <React.Fragment>
      <Box direction="row" height="95%">
        <Item ratio={1}>
          <List
            dataSource={chartList}
            displayExpr="name"
            // height="70%"
            grouped={true}
            collapsibleGroups={true}
            onItemClick={onTypeListItemClick}
          ></List>
        </Item>
        <Item ratio={1}>
          <List
            dataSource={chartSubtypeList}
            // height="70%"
            displayExpr="name"
            onItemClick={onSubtypeListItemClick}
          ></List>
        </Item>
      </Box>
      {/* <Button
        width={120}
        text="취소"
        type="normal"
        stylingMode="outlined"
        onClick={onCancelClick}
      />
      <Button
        width={120}
        text="확인"
        type="success"
        stylingMode="outlined"
        onClick={onOkClick}
      /> */}
      <ButtonOKCancel onCancelClick={onCancelClick} onOkClick={onOkClick} />
    </React.Fragment>
  );
}
